import { Link } from 'react-router-dom';
import { typeLabels, type Movie } from '@/mocks/movies';
import { formatDate } from '@/hooks/useFavorites';

interface MovieCardProps {
  movie: Movie;
  rank?: number;
}

export default function MovieCard({ movie, rank }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-colors"
    >
      <div className="relative w-full aspect-[5/7] overflow-hidden bg-background-200">
        <img
          src={movie.poster}
          alt={`${movie.title} 封面海报`}
          title={`${movie.title} - ${typeLabels[movie.type]} - 丝瓜视频`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute top-2 left-2 px-2 py-0.5 rounded bg-black/65 text-white text-[11px] font-label">
          {typeLabels[movie.type]}
        </span>
        <span className="absolute top-2 right-2 px-2 py-0.5 rounded bg-primary-500 text-background-50 text-[11px] font-label font-bold">
          {movie.rating.toFixed(1)}
        </span>
        {rank !== undefined && (
          <span className="absolute left-0 bottom-0 w-9 h-9 bg-primary-500 text-background-50 font-heading font-black flex items-center justify-center text-base">
            {rank + 1}
          </span>
        )}
        <div className="absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end justify-end px-2 pb-2">
          <span className="text-white text-[11px] font-label flex items-center gap-1">
            <i className="ri-play-circle-fill text-sm"></i> 查看详情
          </span>
        </div>
      </div>
      <div className="p-2.5 md:p-3">
        <h3 className="font-heading text-sm md:text-[15px] font-bold text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
          {movie.title}
        </h3>
        <p className="mt-1 text-[11px] md:text-xs text-foreground-500 truncate">
          {movie.year} · {movie.region} · {movie.genres.slice(0, 2).join('/')}
        </p>
        <p className="mt-0.5 text-[11px] text-foreground-500 truncate">
          导演 {movie.director} · 主演 {movie.cast[0]}
        </p>
        <div className="mt-2 flex items-center justify-between">
          <span className="text-[10px] text-foreground-400 font-label">{formatDate(movie.updatedAt)}</span>
          <span className="text-[10px] text-primary-600 bg-primary-50 px-1.5 py-0.5 rounded whitespace-nowrap">
            {movie.status}
          </span>
        </div>
      </div>
    </Link>
  );
}